export default __webpack_public_path__ + "static/media/play-icon-card.20ed6d13.svg";